import React from "react"

const Card = ({ children, className, onClick = () => { } }) => {
  return (
    <div className={`bg-white boxShadow p-[28px] rounded-[15px] relative ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default Card
